import { GridColDef } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import StatusLabel from '../../common/components/StatusLabel';

export const getStudentProfileColumns = (
  onEdit?: (row: any) => void
): GridColDef[] => {
  return [
    {
      field: 'actions',
      headerName: 'Action',
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title='Edit'>
          <IconButton onClick={() => onEdit && onEdit(params.row)}>
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
      )
    },
    {
      field: 'Student Photo',
      headerName: 'Student Photo',
      minWidth: 120,
      renderCell: (params) => {
        return (
          params.row['Student Photo'] && (
            <img
              src={params.row['Student Photo']}
              alt=''
              style={{ width: '40px', height: '40px', borderRadius: '50%' }}
            />
          )
        );
      }
    },
    {
      field: 'Student Enrollment No',
      headerName: 'Student Enrollment No',
      minWidth: 160
    },
    { field: 'Student Name', headerName: 'Student Name', minWidth: 160 },
    { field: 'Grade', headerName: 'Grade', minWidth: 80 },
    { field: 'Division', headerName: 'Division', minWidth: 80 },
    { field: 'Roll No', headerName: 'Roll No', minWidth: 80 },
    { field: 'Student Type', headerName: 'Student Type', minWidth: 120 },
    {
      field: 'Student Status',
      headerName: 'Student Status',
      minWidth: 120,
      renderCell: (params) => {
        const text = params.row['Student Status'];
        const isActive = String(text).toLowerCase().startsWith('active');
        const status = isActive ? 'ACTIVE' : 'IN_ACTIVE';
        return <StatusLabel status={status} label={String(text)} />;
      }
    },
    { field: 'id', headerName: 'Id', minWidth: 120 },
    { field: 'Student Email', headerName: 'Student Email', minWidth: 180 },
    {
      field: 'Student Photo Uploaded?',
      headerName: 'Student Photo Uploaded?',
      minWidth: 120,
      align: 'center'
    },
    { field: 'House', headerName: 'House', minWidth: 100 },
    { field: 'Student Gender', headerName: 'Student Gender', minWidth: 120 },
    {
      field: 'Student Blood Group',
      headerName: 'Student Blood Group',
      minWidth: 120
    },
    { field: 'Student Country', headerName: 'Student Country', minWidth: 120 },
    { field: 'Student Address', headerName: 'Student Address', minWidth: 160 },
    {
      field: 'Student Nationality',
      headerName: 'Student Nationality',
      minWidth: 120
    },
    {
      field: 'Student Religion',
      headerName: 'Student Religion',
      minWidth: 120
    },
    { field: 'Student Caste', headerName: 'Student Caste', minWidth: 120 },
    {
      field: 'Student Adhaar Card No',
      headerName: 'Student Adhaar Card No',
      minWidth: 160
    },
    {
      field: 'Student Birth Place',
      headerName: 'Student Birth Place',
      minWidth: 140
    },
    {
      field: 'Student Mother Tongue',
      headerName: 'Student Mother Tongue',
      minWidth: 140
    },
    {
      field: 'Student Passport No',
      headerName: 'Student Passport No',
      minWidth: 140
    },
    {
      field: 'Student Passport Expiry',
      headerName: 'Student Passport Expiry',
      minWidth: 140
    },
    { field: 'Student Visa', headerName: 'Student Visa', minWidth: 120 },
    {
      field: 'Emergency Contact Person Name',
      headerName: 'Emergency Contact Person Name',
      minWidth: 180
    },
    {
      field: 'Emergency Contact Person Relation',
      headerName: 'Emergency Contact Person Relation',
      minWidth: 180
    },
    {
      field: 'Emergency Contact Person Contact No',
      headerName: 'Emergency Contact Person Contact No',
      minWidth: 200
    },
    { field: 'Medications', headerName: 'Medications', minWidth: 120 },
    { field: 'Allergies', headerName: 'Allergies', minWidth: 120 },
    {
      field: 'Medical Problems',
      headerName: 'Medical Problems',
      minWidth: 140
    },
    {
      field: 'Medical Practitioner Name',
      headerName: 'Medical Practitioner Name',
      minWidth: 180
    },
    {
      field: 'Medical Practitioner Address',
      headerName: 'Medical Practitioner Address',
      minWidth: 180
    },
    {
      field: 'Medical Practitioner Clinic Phone No',
      headerName: 'Medical Practitioner Clinic Phone No',
      minWidth: 200
    },
    {
      field: 'Medical Practitioner Mobile No',
      headerName: 'Medical Practitioner Mobile No',
      minWidth: 180
    },
    {
      field: 'Guardian Photo Uploaded?',
      headerName: 'Guardian Photo Uploaded?',
      minWidth: 120,
      align: 'center'
    },
    { field: 'Guardian Name', headerName: 'Guardian Name', minWidth: 140 },
    {
      field: 'Guardian Relation',
      headerName: 'Guardian Relation',
      minWidth: 140
    },

    {
      field: 'Guardian Contact No',
      headerName: 'Guardian Contact No',
      minWidth: 140
    },
    {
      field: 'Guardian Email Id',
      headerName: 'Guardian Email Id',
      minWidth: 180
    },

    {
      field: 'Guardian Adhaar Card No',
      headerName: 'Guardian Adhaar Card No',
      minWidth: 160
    },
    {
      field: 'Guardian Pancard No',
      headerName: 'Guardian Pancard No',
      minWidth: 140
    },
    {
      field: 'Guardian Educational Qualification',
      headerName: 'Guardian Educational Qualification',
      minWidth: 200
    },
    {
      field: 'Guardian Profession',
      headerName: 'Guardian Profession',
      minWidth: 160
    },
    {
      field: 'Guardian Organization Name',
      headerName: 'Guardian Organization Name',
      minWidth: 180
    },
    {
      field: 'Guardian Designation',
      headerName: 'Guardian Designation',
      minWidth: 160
    },
    {
      field: 'Guardian Office Contact No',
      headerName: 'Guardian Office Contact No',
      minWidth: 180
    },
    {
      field: 'Guardian Office Address',
      headerName: 'Guardian Office Address',
      minWidth: 180
    },
    {
      field: 'Guardian Website',
      headerName: 'Guardian Website',
      minWidth: 140
    },
    {
      field: 'Guardian Annual Income',
      headerName: 'Guardian Annual Income',
      minWidth: 160
    },
    {
      field: 'Guardian Is Govt Employee?',
      headerName: 'Guardian Is Govt Employee?',
      minWidth: 180
    },
    {
      field: 'Guardian Govt Department Name',
      headerName: 'Guardian Govt Department Name',
      minWidth: 200
    },

    { field: 'Father Name', headerName: 'Father Name', minWidth: 140 },
    {
      field: 'Father Contact No',
      headerName: 'Father Contact No',
      minWidth: 140
    },
    { field: 'Father Email', headerName: 'Father Email', minWidth: 180 },
    {
      field: 'Father Photo Uploaded?',
      headerName: 'Father Photo Uploaded?',
      minWidth: 120,
      align: 'center'
    },
    {
      field: 'Father Adhaar Card No',
      headerName: 'Father Adhaar Card No',
      minWidth: 160
    },
    {
      field: 'Father Pancard No',
      headerName: 'Father Pancard No',
      minWidth: 140
    },
    {
      field: 'Father Educational Qualification',
      headerName: 'Father Educational Qualification',
      minWidth: 200
    },
    {
      field: 'Father Profession',
      headerName: 'Father Profession',
      minWidth: 160
    },
    {
      field: 'Father Organization Name',
      headerName: 'Father Organization Name',
      minWidth: 180
    },
    {
      field: 'Father Designation',
      headerName: 'Father Designation',
      minWidth: 160
    },
    {
      field: 'Father Office Contact No',
      headerName: 'Father Office Contact No',
      minWidth: 180
    },
    {
      field: 'Father Office Address',
      headerName: 'Father Office Address',
      minWidth: 180
    },
    { field: 'Father Website', headerName: 'Father Website', minWidth: 140 },
    {
      field: 'Father Annual Income',
      headerName: 'Father Annual Income',
      minWidth: 160
    },
    {
      field: 'Father is Govt Employee?',
      headerName: 'Father is Govt Employee?',
      minWidth: 180
    },
    {
      field: 'Father Govt Department Name',
      headerName: 'Father Govt Department Name',
      minWidth: 200
    },

    { field: 'Mother Name', headerName: 'Mother Name', minWidth: 140 },
    {
      field: 'Mother Contact No',
      headerName: 'Mother Contact No',
      minWidth: 140
    },
    { field: 'Mother Email', headerName: 'Mother Email', minWidth: 180 },
    {
      field: 'Mother Photo Uploaded?',
      headerName: 'Mother Photo Uploaded?',
      minWidth: 120,
      align: 'center'
    },
    {
      field: 'Mother Adhaar Card No',
      headerName: 'Mother Adhaar Card No',
      minWidth: 160
    },
    {
      field: 'Mother Pancard No',
      headerName: 'Mother Pancard No',
      minWidth: 140
    },
    {
      field: 'Mother Educational Qualification',
      headerName: 'Mother Educational Qualification',
      minWidth: 200
    },
    {
      field: 'Mother Profession',
      headerName: 'Mother Profession',
      minWidth: 160
    },
    {
      field: 'Mother Organization Name',
      headerName: 'Mother Organization Name',
      minWidth: 180
    },
    {
      field: 'Mother Designation',
      headerName: 'Mother Designation',
      minWidth: 160
    },
    {
      field: 'Mother Office Contact No',
      headerName: 'Mother Office Contact No',
      minWidth: 180
    },
    {
      field: 'Mother Office Address',
      headerName: 'Mother Office Address',
      minWidth: 180
    },
    { field: 'Mother Website', headerName: 'Mother Website', minWidth: 140 },
    {
      field: 'Mother Annual Income',
      headerName: 'Mother Annual Income',
      minWidth: 160
    },
    {
      field: 'Mother is Govt Employee?',
      headerName: 'Mother is Govt Employee?',
      minWidth: 180
    },
    {
      field: 'Mother Govt Department',
      headerName: 'Mother Govt Department',
      minWidth: 180
    },

    {
      field: 'Student Date Of Birth',
      headerName: 'Student Date Of Birth',
      minWidth: 140
    },
    {
      field: 'Communication Number',
      headerName: 'Communication Number',
      minWidth: 140
    }
  ];
};
